import React from 'react'

export const FooterContact1: React.FC = () => {
    return (
        <>
            <div className="text-[20px] text-[#FFFFFF] font-bold text-left">
                Свяжитесь с нами
            </div>
            <div className="text-[16px] text-left">
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">E-mail:</p>
                <p className="text-[#FFFFFF]">info@noxsys.ru</p>
            </div>
            <div className="text-[16px] text-left">
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">Телефон:</p>
                <p className="text-[#FFFFFF]">8 (914) 223-44-01</p>
            </div>
        </>
    )
}
